export const RESORT_GEONAME_MAP = Object.freeze({
    "Courchevel 1300 3 Valleys": 3002515,
    "Courchevel 1550 3 Valleys": 7289505,
    "Courchevel 1650 3 Valleys": 7289506,
    "Courchevel 1850 3 Valleys": 3023065,
    "La Tania 3 Valleys": 6355086,
    "Brides-les-Bains": 3030112,
    "Meribel": 2994404,
    "Méribel - Mottaret": 6692267,
    "Les Allues": 3002185,
    "Val Thorens 3 Valleys": 6544556,
    "Les Menuires 3 Valleys": 6545037,
    "Saint-Martin-de-Belleville 3 Valleys": 2978417,
    "Avoriaz 1800 Portes du Soleil": 3035648,
    "Saint-Jean-d'Aulps": 2979355,
    "Abondance Portes du Soleil": 3038745,
    "La Chapelle d'Abondance Portes du Soleil": 3010380,
    "Châtel": 3026177,
    "Morzine. Portes du Soleil": 2991630,
    "Les Gets Portes du Soleil Haute-Savoie": 3000902,
    "Morgins": 2659585,
    "Champoussin": 7670111,
    "Champéry": 2661223,
    "Les Crosets": 6615405,
    "Tignes L'Espace Killy Savoie": 2972607,
    "Tignes Le Lac": 12056097,
    "Tignes Val Claret": 12308848,
    "Tignes - Lavachet": 12308850,
    "Tignes Les Brevieres": 3001725,
    "Val-d'Isère": 2971074,
    "Chamonix": 3027301,
    "Le Tour Mont Blanc": 2999138,
    "Vallorcine": 2970882,
    "Argentière": 3037042,
    "Pila The Aosta Valley": 8957991,
    "St Anton am Arlberg": 2766757,
    "St Christoph am Arlberg": 2766742,
    "Stuben am Arlberg": 2764086,
    "Lech am Arlberg": 2772798,
    "Warth - Vorarlberg": 2761870,
    "Schröcken/ Schroecken": 7667386,
    "Flaine Grand Massif Haute-Savoie": 6621555,
    "Les Carroz Grand Massif": 6692355,
    "Morillon": 2991791,
    "Samoëns/ Samoens": 2976284,
    "Sixt-Fer-à-Cheval": 2974426,
    "Les Arcs 1550.1800. Paradiski": 7580019,
    "Les Arcs 1950.2000. Paradiski": 6692603,
    "Les Arcs 1600. Paradiski": 7579949,
    "Bourg-Saint-Maurice": 3030949,
    "Les Coches": 6949572,
    "Montchavin": 7116442,
    "La Plagne": 6544536,
    "La plagne 1800": 12308887,
    "La Plagne Bellecote": 11002920,
    "La Plagne Villages": 12902571,
    "La Plagne Soleil": 12308888,
    "La Plagne Centre": 6544536,
    "Plagne Montalbert": 2993067,
    "Champagny-en-Vanoise": 3027233,
    "Peisey‑Vallandry": 6690953,
    "Alpe d'Huez": 3008406,
    "Megève Mont Blanc": 2994768,
    "Saint-Gervais-les-Bains": 2979698,
    "Combloux": 3024142,
    "Les Contamines-Montjoie": 3001336,
    "Les Deux Alpes": 6354942,
    "Ischgl": 2775183,
    "Kappl": 2774761,
    "Galtür/ Galtuer": 2778953,
    "La Clusaz": 3010004,
    "Les Villards-sur-Thônes": 2999322,
    "St-Jean-de-Sixt": 2979283,
    "Manigod": 2996205,
    "Sölden/ Soelden": 2764957,
    "Obergurgl": 2770087,
    "Hochgurgl": 3319467,
    "Kühtai/ Kuehtai": 2773276,
    "Vent": 2762441,
    "Zermatt - Täsch/ Taesch": 2657928,
    "Verbier": 2658168,
    "La Tzoumaz": 6559545,
    "Nendaz": 6692544,
    "Veysonnaz": 2658142,
    "Cortina d'Ampezzo": 3177952,
    "Plan de Corones/ Kronplatz": 8956281,
    "Bruneck": 3181480,
    "San Vigilio / St Vigil in Enneberg": 8643247,
    "Olang": 3164949,
    "San Martino in Badia": 6534788,
    "Rasun di Sopra": 3169575,
    "Alta Badia": 3182585,
    "Val Gardena/ Gröden": 3167680,
    "Alpe di Siusi/ Seiser Alm": 3171891,
    "Val di Fassa/ Fassatal": 3180883,
    "Arabba": 3182936,
    "Val di Fiemme/ Fleimstal": 3179333,
    "San Martino di Castrozza": 3168019,
    "Maranza": 3174013,
    "Mühlbach/Rio di Pusteria": 3169345,
    "Gitschberg Jochtal": 3164827,
    "Santa Fosca": 7302788,
    "Selva di Cadore": 3166775,
    "Passo San Pellegrino": 8974450,
    "Falcade-Caviola": 9036126,
    "San Candido": 3168508,
    "Terenten/Terento": 3165796,
    "Valles, Vals": 3164827,
    "Jochtal, Rodeneck": 8950250,
    "Kaltenbach": 2774876,
    "Zell am Ziller": 2760632,
    "Stumm": 2764055,
    "Ried im Zillertal": 3323944,
    "Gerlos": 3323921,
    "Königsleiten/ Koenigsleiten": 6956144,
    "Hochkrimml": 7581158,
    "Fügen/ Fuegen": 2779154,
    "Ramsau im Zillertal": 2768007,
    "Mayrhofen": 2771725,
    "Tux": 11903603,
    "Schwendau": 2765360,
    "Finkenberg": 2779570,
    "Hintertux": 2776225,
    "Kitzbuhel": 2774347,
    "Kirchberg in Tirol": 2774399,
    "Jochberg": 2775068,
    "Thurn Pass": 3323951,
    "Saalbach-Hinterglemm": 2766924,
    "Leogang": 2772641,
    "Fieberbrunn": 2779595,
    "Zell am See": 2760634,
    "Kitzsteinhorn": 3323935,
    "Kaprun": 2774758,
    "La Thuile": 3175062,
    "La Rosière 1850": 3006684,
    "Seez": 2975339,
    "Sestriere": 3166596,
    "Sauze d'Oulx": 3167045,
    "Cesana Torinese": 3178976,
    "Claviere": 3178550,
    "Pragelato Vialattea": 3168832,
    "San Sicario": 3167728,
    "Les Houches Mont Blanc": 3000622,
    "Chinaillon": 3004598,
    "Le Grand-Bornand": 3004041,
    "Zuoz": 2657898,
    "St Moritz": 2658813,
    "Celerina/Schlarigna": 2661241,
    "Silvaplana": 2658588,
    "Madonna di Campiglio": 3174326,
    "Sant'Antonio di Mavignola": 3167391,
    "Pinzolo/ Pinzol": 3170682,
    "Folgarida": 6620302,
    "Marilleva": 6559434,
    "Carisolo": 3180503,
    "Ellmau": 2780135,
    "Going am Wilden Kaiser": 2778396,
    "Scheffau": 2766084,
    "Söll/ Soell": 2764953,
    "Hopfgarten-Markt": 2775541,
    "Westendorf": 2761457,
    "Brixen im Thale": 2781394,
    "Bormio Alta Valtellina": 3181730,
    "Livigno – Carosello/Mottolino": 3174664,
    "Santa Caterina Alta Valtellina": 3167690,
    "Isolaccia": 3175432,
    "Grindelwald": 2660498,
    "Wengen": 2658020,
    "Meiringen - Hasliberg": 2659700,
    "Murren (Parking Stechelberg)": 2659530,
    "Lauterbrunnen": 2659992,
    "Valmorel": 6355130,
    "Doucy - Combelouvière": 9034775,
    "St François - Longchamp": 12305759,
    "Les Diablerets": 2659931,
    "Leysin": 2659900,
    "Les Mosses (Ormont-Dessous)": 2659923,
    "Villars-sur-Ollon": 2658126,
    "Andermatt": 2661750,
    "Sainte Foy": 2980584,
    "Val Cenis": 2973138,
    "Valfréjus": 8643077,
    "La Norma": 6545035,
    "Aussois": 3035989,
    "Bonneval-sur-Arc": 3031697,
    "Bessans": 3033097,
    "Gressoney Monterosa Ski": 3175838,
    "Frachey": 7733095,
    "Champoluc": 3178915,
    "Saint-Jacques-des-Allemands": 3168334,
    "Alagna Valsesia": 3183369,
    "Gstaad": 2660461,
    "Chateau d'Oex": 2661205,
    "Saanen": 2658904,
    "Crans-Montana": 6559506,
    "Montgenevre": 2992546,
    "Les Saisies": 6692265,
    "Notre Dame de Bellecombe": 2990067,
    "Praz sur Arly": 2985543,
    "Flumet": 3018202,
    "Crest-Voland Cohennoz": 3022535,
    "Serfaus - Fiss - Ladis": 2765150,
    "Fiss": 2779525,
    "Ladis": 2773165,
    "Vars. Hautes-Alpes": 6324569,
    "Risoul Domaine de la Foret Blanche": 6295590,
    "Briancon Serre Chevalier": 3030142,
    "Gargellen": 2778859,
    "Silbertal": 2765050,
    "St Gallenkirch": 2766724,
    "Gaschurn": 2778834,
    "Brandnertal": 3324292,
    "Sonnleitn": 11594152,
    "Obertauern": 2769682,
    "Mauterndorf": 2771764,
    "Radstadt": 2768098,
    "Hauser Kaibling": 8987070,
    "Schladming": 2765961,
    "Hochwurzen": 6695525,
    "Riesneralm": 11746604,
    "Ramsau am Dachstein": 2768006,
    "Kals am Grossglockner": 3323885,
    "Flachau": 2779522,
    "Wagrain": 2762102,
    "St. Johann-Alpendorf": 2605968,
    "Zauchensee – Flachauwinkl – Kleinarl": 6620236,
    "Altenmarkt im Pongau": 2782673,
    "Filzmoos": 2779579,
    "Bad Gastein": 2782058,
    "Bad Hofgastein": 2782053,
    "Dorfgastein": 2780798,
    "Sportgastein": 2782058,
    "Maria Alm": 2771951,
    "Dienten am Hochkönig/ Dienten am Hochkoenig": 2780988,
    "Grossarl": 2777905,
    "Lenzerheide": 2659950,
    "Parpan": 2659250,
    "Arosa": 2661712,
    "Fiesch": null,
    "Davos": null,
    "Klosters": null,
    "Arolla": null,
    "Grimentz": null,
    "Zinal": null,
    "Breuil-Cervinia": 3181545,
    "Valtournenche": 3164748,
    "Passo del Tonale": null,
    "Ponte di Legno": null,
    "Courmayeur": 3177872,
    "Valchiavenna-Madesimo": null,
    "Campodolcino": null,
    "Kaunertal": null,
    "Le Corbier - Les Sybelles": null,
    "La Toussuire - Les Sybelles": null,
    "Saint-Sorlin-d'Arves - Les Sybelles": null,
    "Saint-Jean-d'Arves - Les Sybelles": null,
    "Saint Colomban des Villards": null,
    "Engelberg": null,
    "Flims": null,
    "Laax": null,
    "Saas-Fee": null,
    "Hemsedal": null,
    "Trysil": null,
    "Åre": null,
    "Lindvallen": null,
    "Vemdalen": null,
    "Grubigstein-Lermoos": null,
    "Biberwier-Marienberg": null,
    "Garmisch-Partenkirchen": null,
    "Pas de la casa": null,
    "Grau Roig": null,
    "Soldeu el Tarter": null,
    "El Tarter": null,
    "Vail": null,
    "Breckenridge Ski Resort": null,
    "Beaver Creek Village": null,
    "Arrowhead": null,
    "Bachelor Gulch": null,
    "Keyston": null,
    "Aspen Mountain - Ajax": null,
    "Snowmass": null,
    "Squaw Valley Village": null,
    "Alpine Meadows": null,
    "Isola 2000 Village": null,
    "Tatranská Lomnica": null,
    "Štrbské Pleso": null,
    "Starý Smokovec, Hrebienok": null,
    "Podbanské": null,
    "Folgaria-Marilleva": null,
    "Andalo": null,
    "Obereggen": null,
    "Predazzo, Alpe di Pampeago": null,
    "Cavalese": null,
    "Alpe Cermis-Cavalese": null,
    "Passo Rolle": null,
    "Passo di Lavazè": null,
    "Ax-les-Thermes": null,
    "La Molina": null,
    "Masella": null,
    "Sunshine Village Base": null,
    "Main Lodge, Village Base": null,
    "Canyon Lodge Base": null,
    "Eagle Lodge, Eagle Base": null,
    "SilverStar Village": null,
    "Kicking Horse Village": null,
    "Sun Peaks Village": null,
    "Castle Mountain Base": null,
    "Red Mountain": null,
    "Powder Mountain": null,
    "Heavenly Mountain": null,
    "Lake Louise Ski resort": null,
    "Lake Louise": null,
    "Mt. Norquay": null,
    "Banff Sunshine Sunshine Village": null,
} as const);

export type ResortName = keyof typeof RESORT_GEONAME_MAP;

export function getGeonameIdByResortName(resortName: string): number | null {
  return RESORT_GEONAME_MAP[resortName as ResortName] ?? null;
}

export function isValidResortName(name: string): name is ResortName {
  return name in RESORT_GEONAME_MAP;
}
